<template>
  <AButton v-bind="omit(props, ['loading', 'onClick'])" :loading="innerLoading" @click="onBtnClick">
    <slot></slot>
  </AButton>
</template>
<script lang="ts" setup>
import type { ButtonProps } from 'ant-design-vue';
import type { MouseEventHandler } from 'ant-design-vue/es/_util/EventInterface';
import { omit } from 'lodash-es';

interface AXButtonProps extends ButtonProps {
  onClick?: MouseEventHandler;
}

const props = defineProps<AXButtonProps>();

const innerLoading = ref(props.loading);

watch(
  () => props.loading,
  loading => {
    innerLoading.value = loading;
  },
);

async function onBtnClick(e: MouseEvent) {
  innerLoading.value = true;

  try {
    await props.onClick?.(e);
  } catch (error) {
    console.warn('[AXButton] onClick error', error);
  }

  innerLoading.value = false;
}
</script>
<style lang="scss" scoped></style>
